<template>
      <nav class="navbar navbar-light bg-light border-bottom navBar col-md-12">
        <div class="row iconContainer">
          <a class="iconTallos" href="#" >
            <img :src="logo" alt="logo" class="textNavbar"/>
          </a>
        </div>
      </nav>
</template>

<script>
import logo from "../../public/img/icons/rd-conversas-logo.svg"
export default {
  name: "NavBarComponent",
  data() {
    return {
      logo,
    };
  },
};
</script>

<style>
.navBar {
  padding: 27px 0;
  height: 20%;
}
.iconContainer {
  display: contents;
}
.iconTallos {
  display: flex;
  justify-content: center;
}
img {
  width: 200px;
  height: 54px;
}

</style>